export const BUGDETARY = 'bugdetary'
export const ACTUAL = 'actual'
